import React from 'react';
import { isArray } from 'lodash';


export const types = {
	SET_TITLE: 'LAYOUT/SET_TITLE',
	SHOW_TOOLBAR: 'LAYOUT/SHOW_TOOLBAR',
	NOTIFY: 'LAYOUT/SET_NOTIFICATION',
	SET_STATE: 'LAYOUT/SET_STATE',
};

export const initialState = {
	appTitle: 'CRM Portal',
	notifyDuration: 3500,
	notifyText: '',
	notifyOpen: false,
	broadcastTitle: '',
	broadcastText: '',
	broadcastOpen: false,
};

export default (state = initialState, action) => {
	switch (action.type) {
		case types.SET_TITLE:
			return { ...state, appTitle: action.title };
		case types.NOTIFY:
			return buildNotification(state, action);
		case types.SET_STATE:
			return { ...state, ...action.data };

		default:
			return state
	}
}

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),
	setTitle: (title) => ({ type: types.SET_TITLE, title }),
	notify: (text, duration = 3500) => ({ type: types.NOTIFY, text, duration }),
};


function buildNotification(state, action) {
	let text = action.text;
	if (!isArray(text)) {
		text = [text];
	}

	text = text.filter(line => {
		return typeof line === 'string';
	});

	let notifications = (
		<div>
			{text.map((content, index) => {
				return <div key={index}>{content}</div>
			})}
		</div>
	);

	if(!text.length) {
		return {...state, notifyText: notifications, notifyDuration: action.duration, notifyOpen: false};
	}

	console.log('NOTIFY', action.duration, action.text);
	return {...state, notifyText: notifications, notifyDuration: action.duration, notifyOpen: true};
}
